import React from 'react';
import { useDispatch } from 'react-redux';
import { useMutation } from 'react-fetching-library';
import { Modal, Stack, Card, CardContent, Typography, Button } from '@mui/material';
import { SnackbarAlert } from '../../../../components-core/SnackbarAlert';
import { deleteOrderAction } from '../../../../services/request';
import { deleteOrder } from '../../../../services/redux-actions';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const ConfirmDeleteModal = ({ order, open, handleClose, removeOrderFromOrders }) => {
  const dispatch = useDispatch();
  const { mutate } = useMutation(deleteOrderAction);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);

  const handleSubmit = async () => {
    const { error, payload } = await mutate(order.id);
    if (!error) {
      handleClose();
      dispatch(deleteOrder(order.id));
      removeOrderFromOrders(order.id);
    } else {
      setOpenSnackbar(true);
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };

  return (
    <>
      <Modal open={open} onClose={handleClose} >
        <Card sx={{ ...style, width: '45vw', height: '25vh' }}>
          <CardContent sx={{ height: '100%' }}>
            <Stack direction="column" sx={{ height: '100%' }}>
              <Typography variant="h4" textAlign="center">
              Czy na pewno chcesz usunąć zamówienie {order.identifier}?
              </Typography>
              <Stack direction="row" justifyContent="space-around" alignItems="end" flexGrow={1}>
                <Button sx={{ flexGrow: 0.4 }} variant="outlined" onClick={handleClose}>Nie</Button>
                <Button sx={{ flexGrow: 0.4 }} variant="contained" onClick={handleSubmit}>Tak</Button>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </Modal>
      <SnackbarAlert open={openSnackbar} severity="error" message="Nie udało się usunąć zamówienia" onClose={handleCloseSnackbar} />
    </>
  );
};


export default ConfirmDeleteModal;
